// extracted by mini-css-extract-plugin
export default {"album-information-container":"AlbumInformation_album-information-container__78R+I","golden":"AlbumInformation_golden__5Y-G6"};